// 홈 결정 대기 카드 — 시안 C1 `.dcard` (신고 371 §8 결정 2).
// 인라인 [반려][매입 결정] 은 **시트를 연다** — 원클릭 확정이 아니다(매입가·사유는 상세와 같은 DecisionSheets).
import React from 'react';
import { T, R } from '../../../theme';
import { useT, useLocale } from '../../../../i18n/I18nProvider';
import { orderTitle, fmtDate } from '../../fmt';
import LtrText from '../../parts/LtrText';
import MoneyKRW from '../../parts/MoneyKRW';
import Thumb from './Thumb';

var card = { display: 'flex', gap: 12, padding: 12, minWidth: 0, background: T.card, border: '1px solid ' + T.warnBd, borderRadius: R.card };
var body = { flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', gap: 5 };
var title = { fontSize: 13.5, fontWeight: 800, letterSpacing: '-.2px', color: T.ink, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' };
var meta = { display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '4px 12px', fontSize: 11.5, color: T.muted, minWidth: 0 };
var metaVal = { color: T.body, fontWeight: 600 };
var fee = { marginInlineStart: 'auto', fontSize: 11.5, fontWeight: 700, color: T.money };
var actions = { display: 'flex', gap: 7, marginTop: 'auto', paddingTop: 4 };
var btn = {
  flex: 1, height: 32, borderRadius: R.md, fontSize: 12.5, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit',
  display: 'inline-flex', alignItems: 'center', justifyContent: 'center', minWidth: 0
};
var btnReject = Object.assign({}, btn, { background: T.card, border: '1px solid ' + T.dangerBd, color: T.danger });
var btnDecide = Object.assign({}, btn, { background: T.navy, border: '1px solid ' + T.navy, color: T.card });

/// props: { order, busy, onOpen(id), onReject(id), onDecide(id) } — 카드 본문 클릭 = 상세(Jin 2026-09-23), 버튼은 전파 차단
function DecisionCard(props) {
  var t = useT();
  var loc = useLocale();
  var o = props.order || {};
  var open = function () { if (props.onOpen) props.onOpen(o.id); };
  return (<div className="ss-dcard" data-order-id={o.id} role="link" tabIndex={0}
    style={Object.assign({}, card, props.onOpen ? { cursor: 'pointer' } : null)} onClick={open}
    onKeyDown={function (e) { if (e.key === 'Enter') open(); }}>
    <Thumb order={o} w={96} h={72} icon={22} />
    <div style={body}>
      <div style={title}>{orderTitle(t, o)}</div>
      <div style={meta}>
        {o.car_number ? <LtrText>{o.car_number}</LtrText> : null}
        <span>{t('evalTableColInspector')} <b style={metaVal}>{o.inspector_name || '-'}</b></span>
        <LtrText>{fmtDate(loc.locale, o.inspect_date || o.created_at)}</LtrText>
        <MoneyKRW won={o.fee} style={fee} />
      </div>
      <div style={actions}>
        <button type="button" data-action="reject" style={btnReject} disabled={!!props.busy}
          onClick={function (e) { e.stopPropagation(); props.onReject(o.id); }}>{t('evalActionReject')}</button>
        <button type="button" data-action="decide" style={btnDecide} disabled={!!props.busy}
          onClick={function (e) { e.stopPropagation(); props.onDecide(o.id); }}>{t('evalActionDecide')}</button>
      </div>
    </div>
  </div>);
}

export default DecisionCard;
